import { ApiResponse } from "../../shared/types"

function getUserId(): string | undefined {
  try {
    const stored = localStorage.getItem('farmpack-auth');
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.userId || parsed.id;
    }
  } catch {
    // ignore parse errors
  }
  return undefined;
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const userId = getUserId();
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (userId) headers['x-user-id'] = userId;
  
  const res = await fetch(path, { headers, ...init })
  const json = (await res.json()) as ApiResponse<T>
  if (!res.ok || !json.success || json.data === undefined) throw new Error(json.error || 'Request failed')
  return json.data
}